export default "__VITE_ASSET__BdMnYMUq__"